export const filters = () => {

  const btnFilter= '.js-filter-category';
  const active = '.js-filter-active';
  const list = '.js-filters';
  const item =  '.js-item-to-filter';

  const btnFilterCalendar = '.js-filter-calendar';

  const btnSort= '.js-toggle-sort';
  const listToSort =  '.js-list-to-sort';

  //Variables to hide date on program after filtering
  const smallBr = 520;

  const init = () => {
    bind();
  };

  const bind = () => {

    $(btnSort).on('click', function(e) {
      e.preventDefault();
      $(this).attr('data-state', $(this).attr('data-state') == '' ? 'toggled' : '');
      if($(this).attr('data-state') == 'toggled') {
        $(this).text($(this).attr('data-text-toggled'));
      } else {
        $(this).text($(this).attr('data-text-not-toggled'));
      }
      //Toggle class which will reverse the order using flex-direction column-reversed.
      $(listToSort).toggleClass('is-reversed');
    });

    $(btnFilter).on('click', function(e) {
      e.preventDefault();

      //Removing class is-active from active filter, in order to show it again in the list.
      $(btnFilter).removeClass('is-active');
      $(btnFilterCalendar).removeClass('is-active');  
      //Add is-active class to the clicked filter to hide it from the list.
      $(this).addClass('is-active');
      //Then replace text of filter toggle with active filter text.
      $(active).text($(this).text());
      //Close the filters list
      $(list).attr('data-state', $(list).attr('data-state') =='closed' ? 'open' : 'closed');

      //Do the filtering
      let categories = $(this).attr('data-category');
      if(categories == '' || categories == 'all') {
        // $(item).not('.is-filtered-out-by-calendar').removeClass('is-hidden');
        $(item).removeClass('is-hidden');
        $(item).removeClass('is-filtered-out-by-calendar');
        $(item).removeClass('is-filtered-out-by-category');
        document.body.classList.remove("is-filtered");
      } else {
        $(item).addClass('is-hidden');
        $(item).addClass('is-filtered-out-by-category');
        document.body.classList.add("is-filtered");
        $(item+'[data-categories*="'+categories+'"]').removeClass('is-hidden').removeClass('is-filtered-out-by-category');
        // $(item).hasClass('is-filtered-out-by-calendar').addClass('is-hidden');
        // if($(item).hasClass('is-filtered-out-by-calendar')) {

        // }
        
      }

      if(categories == 'event') {
        $(btnFilterCalendar).hide();
      } else {
        $(btnFilterCalendar).show();
      }

    });

    $(btnFilterCalendar).on('click', function(e) {
      e.preventDefault();
      if($(this).hasClass('is-active')) {
        $(item).not('.is-filtered-out-by-category').removeClass('is-hidden');
        $(this).removeClass('is-active');     
      } else {
        //Removing class is-active from active filter, in order to show it again in the list.
        $(btnFilterCalendar).removeClass('is-active');
        //Add is-active class to the clicked filter to hide it from the list.
        $(this).addClass('is-active');      
        //Do the filtering
        let filter = $(this).attr('data-current');

        if(filter == 0 ) {
          // $(item+'[data-current*="'+0+'"]').addClass('is-hidden');
          // if(item).hasClass('is-hidden'){
          // }
          $(item).not('.is-filtered-out-by-category').removeClass('is-hidden');
          $(item+'[data-current*="'+1+'"]').addClass('is-hidden').addClass('is-filtered-out-by-calendar');
        }
        if(filter == 1 ) {
          $(item).not('.is-filtered-out-by-category').removeClass('is-hidden');
          $(item+'[data-current*="'+0+'"]').addClass('is-hidden').addClass('is-filtered-out-by-calendar');
        }
      }
    });

  };

  init();

};
